import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import CodeFalconContent from '../components/CodeFalcon/CodeFalconContent/CodeFalconContent'
import CodeFalconHero from '../components/CodeFalcon/CodeFalconHero/CodeFalconHero'

const CodeFalcon = ({ data }) => {
  const postNode = {
    title: `Code Falcon - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="code-falcon" customTitle />
      <Helmet>
        <title>{`Code Falcon - ${config.siteTitle}`}</title>
      </Helmet>
      <CodeFalconHero />
      <CodeFalconContent />
    </Layout>
  )
}

export default CodeFalcon
